import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./avatar.html";
export let SizeTypes = /*#__PURE__*/function (SizeTypes) {
  SizeTypes["Small"] = "small";
  SizeTypes["Default"] = "default";
  return SizeTypes;
}({});
const containerClassName = 'avatar-container';
class Avatar extends LightningElement {
  constructor(...args) {
    super(...args);
    this.src = void 0;
    this.size = SizeTypes.Default;
    this.alt = '';
    this._error = false;
  }
  handleError() {
    this._error = true;
  }
  get renderDefault() {
    return this._error || !this.src;
  }
  get className() {
    if (this.size === SizeTypes.Small) {
      return containerClassName + ' small';
    }
    return containerClassName;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Avatar, {
  publicProps: {
    src: {
      config: 0
    },
    size: {
      config: 0
    },
    alt: {
      config: 0
    }
  },
  fields: ["_error"]
});
const __lwc_component_class_internal = _registerComponent(Avatar, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;